import { UserHintsComponentWrapper } from "components/Form/components/HelperTextComponentWrapper/UserHintsComponentWrapper";
import { InputComponentProps } from "components/Form/components/InputComponentProps";
import "./Text.scss";

export interface TextProps {
    name: string;
    inputProps?: Omit<InputComponentProps<string>, "value"> & { value?: string };
    attributes?: any; // TODO consider improvement
    errorMessage?: string;
    styleVariant?: "seamless";
    autoFocus?: boolean;
    selectOnFocus?: boolean;
    onEnterKey?: (currentValue: string) => void;
    className?: string;
    reference?: React.MutableRefObject<HTMLInputElement>;
}

export const Text = ({
    name,
    inputProps,
    attributes,
    errorMessage,
    styleVariant,
    autoFocus,
    selectOnFocus,
    onEnterKey,
    className,
    reference,
}: TextProps) => {
    // isReadOnly is a component-level prop, not a DOM attribute — keep it off the <input>.
    const { isReadOnly, ...domInputProps } = inputProps ?? {};
    return (
        <UserHintsComponentWrapper errorMessage={errorMessage}>
            <input
                ref={reference}
                {...attributes}
                {...domInputProps}
                name={name}
                aria-label={name}
                data-testid={name}
                type="text"
                className={`input__field cloudomationText ${styleVariant ?? ""} ${className ?? ""}`}
                autoFocus={autoFocus}
                onFocus={(e) => {
                    if (attributes?.selectOnFocus) {
                        attributes.selectOnFocus();
                    }
                    if (selectOnFocus) {
                        e.currentTarget.select();
                    }
                }}
                onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
                    if (attributes?.onKeyDown) {
                        attributes.onKeyDown(event);
                    }

                    if (event.key === "Enter" && onEnterKey) {
                        onEnterKey((event.target as any).value);
                    }
                }}
                disabled={isReadOnly}
                autoComplete={attributes?.autoComplete ?? name}
            />
        </UserHintsComponentWrapper>
    );
};
